// --------------------- Globais ---------------------\\
import { NumberParam, useQueryParams } from "use-query-params";
import { useEffect, useState } from "react";
import dayjs from "dayjs";

// --------------------- MUI ---------------------\\

import Button from "@mui/material/Button";
//--------------------- Components ---------------------\\

//--------------------- Constants ---------------------\\
import { handleBack } from "./constants/handleBack";
import { handleNext } from "./constants/handleNext";

//--------------------- Hooks ---------------------\\
import { useInteresses } from "./hooks/useInteresses";
import { useMessage } from "../../uteis/mensagens/useMessage";
import {
  CardStyle,
  Container,
  ContainerButton,
  ContainerTitulo,
  Imagem,
  TituloLista,
} from "./styles";

//--------------------- Images ---------------------\\
import imagemFundo from "../../images/imagemfundo.png";
import Localizacao from "./components/Localizacao";
import Periodo from "./components/Periodo";
import TipoInteresse from "./components/TipoInteresse";
import Steps from "./components/Steps";
import { Skeleton, Spin } from "antd";
import { useInserirInteresse } from "./hooks/useInserirInteresse";

type PeriodoObj = {
  inicio: dayjs.Dayjs;
  fim: dayjs.Dayjs;
};
export default function ViewInteressesControle() {
  const [queryParams] = useQueryParams({
    method: NumberParam,
    userid: NumberParam,
    intid: NumberParam,
  });
  const method = queryParams.method;
  const userId = queryParams.userid;
  const intId = queryParams.intid;

  const [activeStep, setActiveStep] = useState<number>(0);
  const [selecionados, setSelecionados] = useState<any[]>([]);
  const [periodos, setPeriodos] = useState<PeriodoObj[]>([]);
  const [objetivos, setObjetivos] = useState<string[]>([]);
  const [origem, setOrigem] = useState<string>("");
  const [quantidadePessoas, setQuantidadePessoas] = useState<number>(0);

  const {
    empreendsSelecionados,
    interesseSelecionado,
    empreendsCidades,
    isLoading,
  } = useInteresses(method!, intId!);

  const {
    cadastrar,
    atualizar,
    isLoading: isLoadingInserir,
    error,
    success,
    warning,
    resetError,
    resetSuccess,
    resetWarning,
  } = useInserirInteresse();

  const interesseData = {
    quantidadePessoas,
    periodos,
    objetivos,
    origem,
  };

  const empreendData = {
    selecionados,
  };

  const { contextHolder, showSuccess, showError, showWarning } = useMessage();

  const [stepsStatus, setStepsStatus] = useState<
    Array<"wait" | "process" | "finish" | "error">
  >(["process", "wait", "wait"]);

  const [bloquearBtn, setBloquearBtn] = useState<boolean>(true);

  const [errorDisplayed, setErrorDisplayed] = useState(false);
  const [successDisplayed, setSuccessDisplayed] = useState(false);
  const [warningDisplayed, setWarningDisplayed] = useState(false);

  // Mensagens de feedback
  useEffect(() => {
    if (!isLoadingInserir) {
      if (success && !successDisplayed) {
        showSuccess(success);
        setSuccessDisplayed(true);
        // Redireciona imediatamente após o loading acabar
        document.location.href = "/interesses";
      }

      if (error && !errorDisplayed) {
        showError(error);
        setErrorDisplayed(true);
        // pode remover o timeout ou deixar 1-2s para ler a mensagem
        setTimeout(() => {
          setErrorDisplayed(false);
          resetError();
        }, 2000);
      }

      if (warning && !warningDisplayed) {
        showWarning(warning);
        setWarningDisplayed(true);
        setTimeout(() => {
          setWarningDisplayed(false);
          resetWarning();
          window.location.href = `/cadastroCotas`;
        }, 2000);
      }
    }
  }, [
    success,
    error,
    warning,
    isLoadingInserir,
    showSuccess,
    showWarning,
    resetSuccess,
    showError,
    successDisplayed,
    errorDisplayed,
    resetWarning,
    resetError,
    warningDisplayed,
  ]);

  return (
    <>
      {isLoading ? (
        <Skeleton />
      ) : (
        <Container>
          {contextHolder}

          {/* Background */}
          <Imagem src={imagemFundo} alt="" />

          <ContainerTitulo>
            <TituloLista>Interesses</TituloLista>
          </ContainerTitulo>

          <CardStyle>
            {/* Steps */}
            <Steps stepsStatus={stepsStatus} />

            {/* Passo 1: Localização */}
            {activeStep === 0 && (
              <Localizacao
                empreendimentos={empreendsCidades}
                empreendsSelecionados={empreendsSelecionados}
                selecionados={selecionados}
                setSelecionados={setSelecionados}
                setBloquearBtn={setBloquearBtn}
              />
            )}

            {/* Passo 2: Período */}
            {activeStep === 1 && (
              <Periodo
                periodos={periodos}
                interesseSelecionado={interesseSelecionado}
                setPeriodos={setPeriodos}
                setBloquearBtn={setBloquearBtn}
              />
            )}

            {/* Passo 3: Tipo de Interesse */}
            {activeStep === 2 && (
              <TipoInteresse
                interesseSelecionado={interesseSelecionado}
                objetivos={objetivos}
                setObjetivos={setObjetivos}
                origem={origem}
                setOrigem={setOrigem}
                quantidadePessoas={quantidadePessoas}
                setQuantidadePessoas={setQuantidadePessoas}
                setBloquearBtn={setBloquearBtn}
              />
            )}
          </CardStyle>

          {/* Botões de navegação */}
          <ContainerButton>
            <Button
              disabled={activeStep === 0 || isLoadingInserir}
              onClick={() =>
                handleBack(
                  activeStep,
                  setActiveStep,
                  stepsStatus,
                  setStepsStatus
                )
              }
            >
              Voltar
            </Button>

            <Button
              disabled={bloquearBtn || isLoadingInserir}
              onClick={() =>
                handleNext(
                  activeStep,
                  setActiveStep,
                  stepsStatus,
                  setStepsStatus,
                  setBloquearBtn,
                  method!,
                  () => cadastrar(userId!, interesseData, empreendData),
                  () =>
                    atualizar(
                      userId!,
                      interesseSelecionado,
                      empreendsSelecionados,
                      interesseData,
                      empreendData
                    )
                )
              }
            >
              {isLoadingInserir ? (
                <Spin size="small" />
              ) : activeStep === 2 ? (
                "Finalizar"
              ) : (
                "Próximo"
              )}
            </Button>
          </ContainerButton>

          {/* Loading global */}
          {isLoadingInserir && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                background: "rgba(255,255,255,0.6)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 9999,
              }}
            >
              <Spin size="large" tip="Processando..." />
            </div>
          )}
        </Container>
      )}
    </>
  );
}
